import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowRight, Loader2, Play } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Logo } from '../components/Logo';
import { useStartDemo } from '../components/demo/useStartDemo';
import { EVENTS, track } from '../lib/analytics';

/**
 * Where the demo ends: its hour ran out, or the visitor chose Exit demo.
 * It used to drop them on the homepage with nothing said; this asks once.
 */
export default function DemoEndedPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { start, loading } = useStartDemo();
  const expired = params.get('reason') === 'expired';

  const signUp = () => {
    track(EVENTS.DEMO_SIGNUP_CLICKED, { source: 'demo_ended' });
    navigate('/register');
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center space-y-6" data-testid="demo-ended">
        <Logo className="w-14 h-14 mx-auto" alt="" />
        <div className="space-y-3">
          <h1 className="text-3xl font-medium">
            {expired ? 'That was the demo hour.' : 'Thanks for trying the demo.'}
          </h1>
          <p className="text-muted-foreground">
            Add your own kit and see what every piece has earned. Free for 30 days, no card needed.
          </p>
          <p className="text-sm text-muted-foreground">
            On your phone? Sign up now and your account will be waiting when you're at a computer.
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <Button size="lg" onClick={signUp} data-testid="demo-ended-signup">
            Create free account
            <ArrowRight />
          </Button>
          <Button size="lg" variant="outline" onClick={start} disabled={loading} data-testid="demo-ended-retry">
            {loading ? <Loader2 className="animate-spin" /> : <Play />}
            Try the demo again
          </Button>
        </div>
        <p className="text-sm text-muted-foreground">
          <Link to="/" className="text-clay underline underline-offset-4 hover:text-foreground">
            Back to the homepage
          </Link>
          {' · '}
          <Link to="/login" className="text-clay underline underline-offset-4 hover:text-foreground">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
